/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class CheckInterval
 */
import { Type } from 'class-transformer';

export class CheckInterval {
  @Type(() => Date)
  private readonly last: Date;

  @Type(() => Date)
  private readonly next: Date;

  constructor(last: Date, next: Date) {
    this.last = last;
    this.next = next;
  }

  public getLast(): Date | null {
    return this.last || null;
  }

  public getNext(): Date | null {
    return this.next || null;
  }

  public toPlain(): { next: Date | null; last: Date | null } {
    return {
      next: this.getNext(),
      last: this.getLast()
    };
  }
}
